module.exports = __webpack_public_path__ + "static/hong-kong-c87382b89b5a7e1bb21a4cf92905d401.svg";